import React from "react";
import Badge from "reactstrap/es/Badge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { UncontrolledTooltip } from "reactstrap";

const BadgeWithIcon = ({ type, style, text, showIcon, tooltip }) => {
    // Generate a unique ID for the tooltip target
    const tooltipId = `badge-tooltip-${Math.random().toString(36).substr(2, 9)}`;
    
    return (
        <>
            <Badge
                id={tooltip ? tooltipId : undefined}
                color={type.color}
                style={style}
                onClick={(event)=>{
                    event.stopPropagation();
                    event.preventDefault();
                }}
                className="rounded-capsule fs--1 d-block"
            >
                {text}
                {showIcon && (
                    <FontAwesomeIcon
                        icon={type.icon}
                        className="fs--4"
                        color={type.iconColor}
                    />
                )}
            </Badge>
            
            {tooltip && (
                <UncontrolledTooltip 
                    placement="top"
                    target={tooltipId} 
                    autohide={true}>
                    {tooltip}
                </UncontrolledTooltip>
            )}
        </>
    );
};

export default BadgeWithIcon;